import { LandingKeepUp } from "./LandingKeepUp"
import { LandingLogoBrackyWorld } from "./LandingLogoBrackyAlt"
import { LandingLogoLiveTheGameHorizontal } from "./LandingLogoLiveTheGameHorizontal"
import { LandingLogoLockupOutineReverse } from "./LandingLogoLockupOutineReverse"

export function LandingFooter() {
  return (
    <>
      <LandingKeepUp />
      <footer className="relative z-120 pt-4 md:-mb-8">
        {/* New Bracky Alt Logo */}
        <div className="flex justify-center mb-[.8rem] md:mb-7">
          <LandingLogoBrackyWorld className="md:h-[6.7rem] h-[3.6rem] text-[#001CFF]" />
        </div>

        {/* Oversized brand lockup */}
        <div className="flex justify-center mb-3 md:mb-8">
          <LandingLogoLockupOutineReverse className="w-[90vw] text-[#76829b]/70" />
        </div>

        <div className="max-w-4xl mx-auto px-6">
          {/* "LIVE THE GAME" Logo */}
          <div className="flex justify-center mb-6 md:mb-12 z-0">
            <LandingLogoLiveTheGameHorizontal className="h-4 md:h-16 w-auto text-[#76829b]/70" />
          </div>

          {/* Footer */}
          {/* TODO: fix scroll issue caused by below section */}
          {/*<div className="text-center text-[#76829b]/70 text-sm">
            <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-6">
              <div className="flex items-center justify-center space-x-2">
                <LandingLogoNilli className="w-[3.8rem] h-auto -translate-y-[.3rem]  mr-[.31rem] text-[#76829b]/70" />
                <span>© 2025 Nilli, Inc. All rights reserved.</span>
              </div>
              <div className="flex space-x-4">
                <button type="button" className="hover:text-white transition-colors">
                  Privacy Policy
                </button>
                <button type="button" className="hover:text-white transition-colors">
                  Terms of Service
                </button>
                <button type="button" className="hover:text-white transition-colors">
                  Support
                </button>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-white/10">
              <p className="text-xs text-[#76829b]/70 mb-1">
                Bracky is an autonomous sports agent who uses tokens from your Bracket balance for in-feed trading. You
                fully own your wallet and can withdraw at any time.
              </p>
              <p className="text-xs text-[#76829b]/70">Trade responsibly. Must be 18+ to participate.</p>
            </div>
          </div>*/}
        </div>
      </footer>
      {/* Decorative football-field background with CRT scanlines overlay */}
      <div className="relative w-full">
        {/* Football field image */}
        <img
          src="https://a.bracky.app/assets/landing/backgrounds/footer-football-field-4.webp"
          alt="Football field background"
          className="w-full block select-none pointer-events-none"
          draggable="false"
          loading="lazy"
          style={{
            verticalAlign: "bottom",
            display: "block",
          }}
        />

        {/* Scanlines overlay – replicates effect from LandingBackground */}
        <div className="absolute inset-0 pointer-events-none scanlines mix-blend-overlay" />
      </div>
    </>
  )
}
